import { TerrainType, } from "./types.js";
export function terrainModifiersFor(terrain, track) {
    return terrain === TerrainType.Wall || terrain === TerrainType.Unknown
        ? { drag: 0, maxSpeed: 0, grip: 0 }
        : track;
}
export class ArrayTerrainSampler {
    width;
    height;
    terrain;
    checkpoints;
    zones;
    constructor(width, height, terrain, checkpoints, zones) {
        if (!Number.isInteger(width) ||
            !Number.isInteger(height) ||
            width <= 0 ||
            height <= 0 ||
            terrain.length !== width * height) {
            throw new Error("Terrain buffer dimensions do not match");
        }
        if (checkpoints && checkpoints.length !== width * height)
            throw new Error("Checkpoint buffer dimensions do not match");
        if (zones && zones.length !== width * height)
            throw new Error("Zone buffer dimensions do not match");
        this.width = width;
        this.height = height;
        this.terrain = terrain;
        this.checkpoints = checkpoints ?? new Uint8Array(width * height);
        this.zones = zones ?? new Uint8Array(width * height);
    }
    sample(x, y) {
        const px = Math.round(x);
        const py = Math.round(y);
        if (px < 0 || py < 0 || px >= this.width || py >= this.height) {
            return { terrain: TerrainType.Wall, checkpointColor: null, zones: 0 };
        }
        const index = py * this.width + px;
        return {
            terrain: terrainFromByte(this.terrain[index] ?? 3),
            checkpointColor: checkpointFromByte(this.checkpoints[index] ?? 0),
            zones: this.zones[index] ?? 0,
        };
    }
}
function terrainFromByte(value) {
    return value === 0
        ? TerrainType.Road
        : value === 1
            ? TerrainType.Grass
            : value === 2
                ? TerrainType.Gravel
                : TerrainType.Wall;
}
function checkpointFromByte(value) {
    return value === 1
        ? 0xff0000
        : value === 2
            ? 0x00ff00
            : value === 3
                ? 0x0000ff
                : null;
}
